import React from 'react'
import { formatUnderscoreCase } from '../../utils'

interface DistributionChartProps {
  data: { [key: string]: number }
  title: string
}

const DistributionChart: React.FC<DistributionChartProps> = ({ data, title }) => {
  const maxValue = Math.max(...Object.values(data))
  const entries = Object.entries(data)
  const firstKey = entries[0][0]
  const middleKey = entries[Math.floor(entries.length / 2)][0]
  const lastKey = entries[entries.length - 1][0]

  return (
    <div className="bg-blue-700 bg-opacity-50 rounded-lg p-2">
      <h4 className="text-xs font-semibold mb-1 text-white">{title}</h4>
      <div className="flex flex-col h-24">
        <div className="flex items-end h-20 justify-between px-1">
          {entries.map(([key, value]) => (
            <div key={key} className="flex flex-col items-center w-4 h-full">
              <div className="flex-grow w-full flex flex-col justify-end">
                <div className="w-full bg-blue-300 rounded-t" style={{ height: `${(value / maxValue) * 100}%` }}></div>
              </div>
            </div>
          ))}
        </div>
        <div className="h-4 flex justify-between items-center px-1 mt-1">
          <div className="text-[9px] text-white truncate">{formatUnderscoreCase(firstKey)}</div>
          <div className="text-[9px] text-white truncate">{formatUnderscoreCase(middleKey)}</div>
          <div className="text-[9px] text-white truncate">{formatUnderscoreCase(lastKey)}</div>
        </div>
      </div>
    </div>
  )
}

export default DistributionChart
